<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Extra-dim Overlay -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <!-- =========================
       CONTENT LAYER (Split Screen)
  =========================== -->
  <div class="container-fluid position-relative z-1 min-vh-100">
    <div class="row d-flex min-vh-100">

      <!-- Left illustration/marketing column (show from md and up) -->
      <div class="col-6 col-md-6 d-none d-md-flex bg-warning text-white login-panel-left">
        <div class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 px-5">
          <div class="absolute-top-left">
            <router-link
              to="/"
              class="auth-logo mb-2 text-decoration-none d-inline-block"
              aria-label="NPI Home"
            ></router-link>
          </div>
          <h3 class="fw-bold mb-4 text-dark">
            Manage Your B-BBEE Compliance with Confidence
          </h3>
          <p class="text-dark text-sm">
            Track programmes, prepare audit packs, and achieve your target BEE level with our comprehensive platform.
          </p>
        </div>
      </div>

      <!-- Right column: reset form (full width on mobile, half on md+) -->
      <div class="col-12 col-md-6 d-flex align-items-center justify-content-center vh-100 flex-column">
        <div class="p-4 p-md-5 rounded-4 w-100" style="max-width:520px;">

          <!-- Heading -->
          <h3 class="fw-bold mb-1 text-white">Reset Password</h3>

          <p class="text-white-50 mb-4 text-sm">
            Enter your email and we’ll send you a link to reset your password.
          </p>

          <!-- ERROR MESSAGE -->
          <div v-if="error_message" class="alert alert-danger alert-dismissible fade show rounded-3" role="alert">
            {{ error_message }}
            <button type="button" class="btn-close" @click="error_message = ''"></button>
          </div>

          <!-- SUCCESS MESSAGE -->
          <div v-if="success_message" class="alert alert-success alert-dismissible fade show rounded-3" role="alert">
            {{ success_message }}
            <button type="button" class="btn-close" @click="success_message = ''"></button>
          </div>

          <!-- LOADING STATE -->
          <div v-if="is_loading" class="text-center mb-3">
            <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
            <span class="text-white-50">Sending reset link...</span>
          </div>

          <!-- RESET FORM (preserve functionality) -->
          <form @submit.prevent="handleReset" v-if="!is_loading">
            <div class="mb-3">
              <label class="form-label text-xs text-white-50">Email</label>
              <input
                v-model="email"
                type="email"
                class="form-control form-control-sm rounded-3 bg-transparent text-white border-secondary placeholder-white"
                placeholder="Enter your email"
                required
                :disabled="is_loading"
              />
            </div>

            <button class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3" :disabled="is_loading">
              Send Reset Link
            </button>

            <p class="text-center text-white-50 text-xs mb-0">
              Remember your password?
              <router-link to="/login" class="text-decoration-none text-primary">Login</router-link>
            </p>
          </form>

        </div>
      </div>

    </div>
  </div>
</div>
